import { useWatchField } from "../useWatchField/useWatchField";
import { hasErrorDep } from "../../dependencySymbols/dependencySymbols";
export function useWatchHasError() {
    var ref = useWatchField([
        hasErrorDep
    ]), hasError = ref[hasErrorDep];
    return !!hasError;
}
